import { Access } from "@p0security/shared/types/access/index";
import { startCase } from "lodash-es";

import {
  aliasParameter,
  parentParameter,
  requiredProviderParameter,
  sudoParameter,
} from "./parameters.ts";

export const commonParentAccess = (label: string) =>
  Access({
    description: `Ability to SSH into any instance in ${label}`,
    label: startCase(label),
    maturity: "ga",
    delegation: {},
    generated: {},
    parameters: {
      sudo: sudoParameter,
      provider: { ...requiredProviderParameter, optional: true },
      parent: { ...parentParameter(label), optional: undefined },
      alias: aliasParameter,
    },
    render: { locator: "parent", policy: "sudo" } as const,
  });
